import { render, staticRenderFns } from "./AgreementCreate.vue?vue&type=template&id=5b82b62a&scoped=true&"
import script from "./AgreementCreate.vue?vue&type=script&lang=js&"
export * from "./AgreementCreate.vue?vue&type=script&lang=js&"
import style0 from "./AgreementCreate.vue?vue&type=style&index=0&id=5b82b62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82b62a",
  null
  
)

export default component.exports